// 2023 Topps Finest Star Wars — authored by hand (2026-08-22)
// =============================================================================
// CARDS: transcribed from the official Topps checklist PDF
// (STW2377-2023StarWarsFinestChecklist.pdf, 6 pages, 256 numbered cards).
// Every card number and name below comes from that PDF, and the per-sub-set
// counts were re-verified independently against TCDB (sid 393902) and
// breakninja's full 2,120-row parallel table: base 100, extended base 25,
// Tales of the Jedi 22, Finest Moments 25, Finest Warriors 25, Enemies of the
// Empire 9, Finest Autographs 44, Prime Autographs 6. All three sources agree.
//
// PARALLELS: the Topps PDF lists no parallels at all, so the ladders come from
// TCDB's Inserts-and-Related-Sets index cross-checked line by line against
// breakninja's table, which carries an explicit print run per parallel. The two
// agree on every tier. Enemies of the Empire is foil board rather than chrome —
// its ladder is Gold/Orange/Black/Red Foil with a Broken Glass Foil 1/1 and no
// Superfractor. Finest Autographs carry a Wave twin at every colour except Aqua.
//
// Rule 7: Prime Autographs are numbered /10 on the base card, so the sub-set
// carries a blank-name serial slot at 10. Every other sub-set's base card is
// unnumbered (confirmed by breakninja's blank print-run column), so none of
// them take a slot. Sketches are 1/1 by design.
//
// NAMING: Tales of the Jedi cards append the PDF's second column (the character
// descriptor) because TOTJ-5 and TOTJ-6 are otherwise both "Qui-Gon Jinn".
// Autographs concatenate signer + character, matching the convention in
// 2026-the-national.js and 2025-masterwork.js. One normalisation: the PDF
// prints FM-25 as "THE GRAND INQUISITOR" while FN-44 in the same PDF is title
// case, so FM-25 is stored title case here.
//
// KNOWN GAP — TALES OF THE JEDI AUTOGRAPHS: TCDB and Beckett both say this
// sub-set exists at /99 (with Gold /50, Orange /25, Black /10, Red /5 and a
// Superfractor 1/1). It is deliberately NOT in this file: it appears in neither
// the official Topps PDF nor breakninja's table, and TCDB's card list for it is
// a verbatim clone of the 22 Tales of the Jedi insert character names rather
// than a signer list, which cannot be right. Add it once a real signer list is
// sourced from a specimen or a Topps document.
//
// SKETCH ARTISTS: sourced from TCDB (43 regular, 12 shaped). The sketch lines
// themselves are confirmed by Topps pack odds (1:82 and 1:613) and by Beckett
// and Cardboard Connection; the artist names are single-source.
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [
        { id: "refractor", name: "Refractor", print_run: null, color: "#c8d8f0" },
        { id: "aqua-refractor", name: "Aqua Refractor", print_run: 199, color: "#00e5ff" },
        { id: "green-refractor", name: "Green Refractor", print_run: 99, color: "#00e676" },
        { id: "purple-raywave-refractor", name: "Purple RayWave Refractor", print_run: 75, color: "#b060ff" },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "FN-1", name: "Ahsoka Tano" },
        { n: "FN-2", name: "Hera Syndulla" },
        { n: "FN-3", name: "Ezra Bridger" },
        { n: "FN-4", name: "Grand Admiral Thrawn" },
        { n: "FN-5", name: "Sabine Wren" },
        { n: "FN-6", name: "Cassian Andor" },
        { n: "FN-7", name: "Mon Mothma" },
        { n: "FN-8", name: "Luthen Rael" },
        { n: "FN-9", name: "Bix Caleen" },
        { n: "FN-10", name: "Syril Karn" },
        { n: "FN-11", name: "Kino Loy" },
        { n: "FN-12", name: "Vel Sartha" },
        { n: "FN-13", name: "Melshi" },
        { n: "FN-14", name: "Dedra Meero" },
        { n: "FN-15", name: "Saw Gerrera" },
        { n: "FN-16", name: "Maarva Andor" },
        { n: "FN-17", name: "Arvel Skeen" },
        { n: "FN-18", name: "Kit Fisto" },
        { n: "FN-19", name: "Count Dooku" },
        { n: "FN-20", name: "Aayla Secura" },
        { n: "FN-21", name: "Luminara Unduli" },
        { n: "FN-22", name: "Boba Fett" },
        { n: "FN-23", name: "Fennec Shand" },
        { n: "FN-24", name: "Krrsantan" },
        { n: "FN-25", name: "Garsa Fwip" },
        { n: "FN-26", name: "Stormtrooper" },
        { n: "FN-27", name: "Han Solo" },
        { n: "FN-28", name: "Princess Leia" },
        { n: "FN-29", name: "Wedge Antilles" },
        { n: "FN-30", name: "Poe Dameron" },
        { n: "FN-31", name: "General Leia Organa" },
        { n: "FN-32", name: "C-3PO" },
        { n: "FN-33", name: "Commander D'Acy" },
        { n: "FN-34", name: "Snap Wexley" },
        { n: "FN-35", name: "Maz Kanata" },
        { n: "FN-36", name: "Rey" },
        { n: "FN-37", name: "Finn" },
        { n: "FN-38", name: "BB-8" },
        { n: "FN-39", name: "Rose Tico" },
        { n: "FN-40", name: "Reva" },
        { n: "FN-41", name: "The Fifth Brother" },
        { n: "FN-42", name: "The Fourth Sister" },
        { n: "FN-43", name: "Darth Vader" },
        { n: "FN-44", name: "The Grand Inquisitor" },
        { n: "FN-45", name: "Obi-Wan Kenobi" },
        { n: "FN-46", name: "Luke Skywalker" },
        { n: "FN-47", name: "Princess Leia Organa" },
        { n: "FN-48", name: "Owen Lars" },
        { n: "FN-49", name: "Beru Lars" },
        { n: "FN-50", name: "Bail Organa" },
        { n: "FN-51", name: "Tala Durith" },
        { n: "FN-52", name: "NED-B" },
        { n: "FN-53", name: "Qui-Gon Jinn" },
        { n: "FN-54", name: "First Order Stormtrooper" },
        { n: "FN-55", name: "Luke Skywalker" },
        { n: "FN-56", name: "Lando Calrissian" },
        { n: "FN-57", name: "Jabba the Hutt" },
        { n: "FN-58", name: "Nien Nunb" },
        { n: "FN-59", name: "R2-D2" },
        { n: "FN-60", name: "Mace Windu" },
        { n: "FN-61", name: "General Grievous" },
        { n: "FN-62", name: "Yoda" },
        { n: "FN-63", name: "Chewbacca" },
        { n: "FN-64", name: "Babu Frik" },
        { n: "FN-65", name: "Zorii Bliss" },
        { n: "FN-66", name: "Kylo Ren" },
        { n: "FN-67", name: "Dark Rey" },
        { n: "FN-68", name: "Jannah" },
        { n: "FN-69", name: "General Hux" },
        { n: "FN-70", name: "Ochi of Bestoon" },
        { n: "FN-71", name: "Jyn Erso" },
        { n: "FN-72", name: "Galen Erso" },
        { n: "FN-73", name: "Baze Malbus" },
        { n: "FN-74", name: "Chirrut Îmwe" },
        { n: "FN-75", name: "Director Krennic" },
        { n: "FN-76", name: "K-2SO" },
        { n: "FN-77", name: "Grand Moff Tarkin" },
        { n: "FN-78", name: "Admiral Raddus" },
        { n: "FN-79", name: "Bodhi Rook" },
        { n: "FN-80", name: "Edrio Two Tubes" },
        { n: "FN-81", name: "General Jan Dodonna" },
        { n: "FN-82", name: "Maul" },
        { n: "FN-83", name: "Dryden Vos" },
        { n: "FN-84", name: "Qi'ra" },
        { n: "FN-85", name: "Enfys Nest" },
        { n: "FN-86", name: "L3-37" },
        { n: "FN-87", name: "Rio Durant" },
        { n: "FN-88", name: "Tobias Beckett" },
        { n: "FN-89", name: "Weazel" },
        { n: "FN-90", name: "Chewbacca" },
        { n: "FN-91", name: "Han Solo" },
        { n: "FN-92", name: "IG-11" },
        { n: "FN-93", name: "Omera" },
        { n: "FN-94", name: "The Mandalorian" },
        { n: "FN-95", name: "Grogu" },
        { n: "FN-96", name: "Bo-Katan Kryze" },
        { n: "FN-97", name: "Paz Vizsla" },
        { n: "FN-98", name: "Moff Gideon" },
        { n: "FN-99", name: "Greef Karga" },
        { n: "FN-100", name: "The Armorer" },
    ],
  },
  {
    id: "extended-base",
    type: "insert",
    title: "EXTENDED BASE",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "EB-1", name: "Ahsoka Tano" },
        { n: "EB-2", name: "Cassian Andor" },
        { n: "EB-3", name: "Dedra Meero" },
        { n: "EB-4", name: "Boba Fett" },
        { n: "EB-5", name: "Fennec Shand" },
        { n: "EB-6", name: "Han Solo" },
        { n: "EB-7", name: "Princess Leia" },
        { n: "EB-8", name: "Darth Vader" },
        { n: "EB-9", name: "Obi-Wan Kenobi" },
        { n: "EB-10", name: "Qui-Gon Jinn" },
        { n: "EB-11", name: "Luke Skywalker" },
        { n: "EB-12", name: "Mace Windu" },
        { n: "EB-13", name: "General Grievous" },
        { n: "EB-14", name: "Kylo Ren" },
        { n: "EB-15", name: "Jyn Erso" },
        { n: "EB-16", name: "Director Krennic" },
        { n: "EB-17", name: "Grand Moff Tarkin" },
        { n: "EB-18", name: "Maul" },
        { n: "EB-19", name: "Qi'ra" },
        { n: "EB-20", name: "Tobias Beckett" },
        { n: "EB-21", name: "Chewbacca" },
        { n: "EB-22", name: "IG-11" },
        { n: "EB-23", name: "The Mandalorian" },
        { n: "EB-24", name: "Grogu" },
        { n: "EB-25", name: "Bo-Katan Kryze" },
    ],
  },
  {
    id: "tales-of-the-jedi",
    type: "insert",
    title: "TALES OF THE JEDI",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "TOTJ-1", name: "Darth Sidious Dark Lord of the Sith" },
        { n: "TOTJ-2", name: "Anakin Skywalker Jedi Knight" },
        { n: "TOTJ-3", name: "Jedi Master Dooku Jedi Master" },
        { n: "TOTJ-4", name: "Yaddle Jedi Master" },
        { n: "TOTJ-5", name: "Qui-Gon Jinn Jedi Knight" },
        { n: "TOTJ-6", name: "Qui-Gon Jinn Jedi Master" },
        { n: "TOTJ-7", name: "Mace Windu Jedi Master" },
        { n: "TOTJ-8", name: "Gantika Togruta Village Elder" },
        { n: "TOTJ-9", name: "Nak-il Tano Togruta Male" },
        { n: "TOTJ-10", name: "Pav-ti Tano Togruta Female" },
        { n: "TOTJ-11", name: "Senator Dagonet Galactic Republic Senator" },
        { n: "TOTJ-12", name: "The Senator's Son" },
        { n: "TOTJ-13", name: "Hanel Senate Guard" },
        { n: "TOTJ-14", name: "Semage Senate Guard" },
        { n: "TOTJ-15", name: "Senator Larik Galactic Republic Senator" },
        { n: "TOTJ-16", name: "Raxus Droid" },
        { n: "TOTJ-17", name: "Jocasta Nu Jedi Master" },
        { n: "TOTJ-18", name: "Ahsoka Tano Jedi Padawan" },
        { n: "TOTJ-19", name: "Captain Rex Clone Trooper Captain" },
        { n: "TOTJ-20", name: "Obi-Wan Kenobi Jedi Knight" },
        { n: "TOTJ-21", name: "Bail Organa Galactic Republic Senator" },
        { n: "TOTJ-22", name: "Inquisitor Force-sensitive Interrogator" },
    ],
  },
  {
    id: "finest-moments",
    type: "insert",
    title: "FINEST MOMENTS",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "FM-1", name: "Hera Syndulla" },
        { n: "FM-2", name: "Sabine Wren" },
        { n: "FM-3", name: "Ezra Bridger" },
        { n: "FM-4", name: "Fennec Shand" },
        { n: "FM-5", name: "Reva" },
        { n: "FM-6", name: "The Armorer" },
        { n: "FM-7", name: "Luthen Rael" },
        { n: "FM-8", name: "Mon Mothma" },
        { n: "FM-9", name: "Bix Caleen" },
        { n: "FM-10", name: "Dedra Meero" },
        { n: "FM-11", name: "Syril Karn" },
        { n: "FM-12", name: "Paz Vizsla" },
        { n: "FM-13", name: "BB-8" },
        { n: "FM-14", name: "C-3PO" },
        { n: "FM-15", name: "R2-D2" },
        { n: "FM-16", name: "The Emperor" },
        { n: "FM-17", name: "Qi'ra" },
        { n: "FM-18", name: "Admiral Ackbar" },
        { n: "FM-19", name: "Saw Gerrera" },
        { n: "FM-20", name: "JAR JAR Binks" },
        { n: "FM-21", name: "Cad Bane" },
        { n: "FM-22", name: "Padmé Amidala" },
        { n: "FM-23", name: "Count Dooku" },
        { n: "FM-24", name: "Grand Admiral Thrawn" },
        { n: "FM-25", name: "The Grand Inquisitor" },
    ],
  },
  {
    id: "finest-warriors",
    type: "insert",
    title: "FINEST WARRIORS",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "FW-1", name: "Rey" },
        { n: "FW-2", name: "Kylo Ren" },
        { n: "FW-3", name: "Luke Skywalker" },
        { n: "FW-4", name: "Han Solo" },
        { n: "FW-5", name: "Chewbacca" },
        { n: "FW-6", name: "Princess Leia Organa" },
        { n: "FW-7", name: "Finn" },
        { n: "FW-8", name: "Poe Dameron" },
        { n: "FW-9", name: "Ahsoka Tano" },
        { n: "FW-10", name: "Cassian Andor" },
        { n: "FW-11", name: "Obi-Wan Kenobi" },
        { n: "FW-12", name: "Darth Vader" },
        { n: "FW-13", name: "Darth Maul" },
        { n: "FW-14", name: "Kanan Jarrus" },
        { n: "FW-15", name: "The Mandalorian" },
        { n: "FW-16", name: "Bo-Katan Kryze" },
        { n: "FW-17", name: "Krrsantan" },
        { n: "FW-18", name: "Boba Fett" },
        { n: "FW-19", name: "Yoda" },
        { n: "FW-20", name: "Qui-Gon Jinn" },
        { n: "FW-21", name: "General Grievous" },
        { n: "FW-22", name: "Anakin Skywalker" },
        { n: "FW-23", name: "Mace Windu" },
        { n: "FW-24", name: "Asajj Ventress" },
        { n: "FW-25", name: "Hunter" },
    ],
  },
  {
    id: "enemies-of-the-empire",
    type: "insert",
    title: "ENEMIES OF THE EMPIRE",
    parallels: [
        { id: "gold-foil", name: "Gold Foil", print_run: 50, color: "#f0c040" },
        { id: "orange-foil", name: "Orange Foil", print_run: 25, color: "#ff9d52" },
        { id: "black-foil", name: "Black Foil", print_run: 10, color: "#a8a8b4" },
        { id: "red-foil", name: "Red Foil", print_run: 5, color: "#ff9d8a" },
        { id: "broken-glass-foil", name: "Broken Glass Foil", print_run: 1, color: "#d9e8fa" },
      ],
    cards: [
        { n: "EOTE-1", name: "Han Solo" },
        { n: "EOTE-2", name: "Saw Gerrera" },
        { n: "EOTE-3", name: "Luke Skywalker" },
        { n: "EOTE-4", name: "Princess Leia Organa" },
        { n: "EOTE-5", name: "Obi-Wan Kenobi" },
        { n: "EOTE-6", name: "Ezra Bridger" },
        { n: "EOTE-7", name: "Cassian Andor" },
        { n: "EOTE-8", name: "Ahsoka Tano" },
        { n: "EOTE-9", name: "Jyn Erso" },
    ],
  },
  {
    id: "finest-autographs",
    type: "auto",
    title: "FINEST AUTOGRAPHS",
    parallels: [
        { id: "aqua-refractor", name: "Aqua Refractor", print_run: 199, color: "#00e5ff" },
        { id: "green-refractor", name: "Green Refractor", print_run: 99, color: "#00e676" },
        { id: "green-wave-refractor", name: "Green Wave Refractor", print_run: 99, color: "#8ef0b8" },
        { id: "purple-refractor", name: "Purple Refractor", print_run: 75, color: "#b060ff" },
        { id: "purple-wave-refractor", name: "Purple Wave Refractor", print_run: 75, color: "#d0a8ff" },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "gold-wave-refractor", name: "Gold Wave Refractor", print_run: 50, color: "#f7dc94" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "orange-wave-refractor", name: "Orange Wave Refractor", print_run: 25, color: "#ffb072" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "black-wave-refractor", name: "Black Wave Refractor", print_run: 10, color: "#c0c4d4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "red-wave-refractor", name: "Red Wave Refractor", print_run: 5, color: "#ff9090" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "FA-AA", name: "Adria Arjona Bix Caleen" },
        { n: "FA-AB", name: "Ahmed Best Jar Jar Binks" },
        { n: "FA-AS", name: "Andy Serkis Kino Loy" },
        { n: "FA-BM", name: "Bobby Moynihan Orka" },
        { n: "FA-CJ", name: "Carey Jones Krrsantan" },
        { n: "FA-CP", name: "Chad Parker Padu Cherd" },
        { n: "FA-CS", name: "Christopher Sean Kazuda Xiono" },
        { n: "FA-DG", name: "Denise Gough Dedra Meero" },
        { n: "FA-DL", name: "Diego Luna Cassian Andor" },
        { n: "FA-DW", name: "Debra Wilson Cere Junda" },
        { n: "FA-EM", name: "Ewan McGregor Obi-Wan Kenobi" },
        { n: "FA-FM", name: "Faye Marsay Vel Sartha" },
        { n: "FA-FP", name: "Freddie Prinze Jr. Kanan Jarrus" },
        { n: "FA-FS", name: "Fiona Shaw Maarva Andor" },
        { n: "FA-FW", name: "Forest Whitaker Saw Gerrera" },
        { n: "FA-GB", name: "Gary Beadle Clem Andor" },
        { n: "FA-GF", name: "Grant Feely Luke Skywalker" },
        { n: "FA-GO", name: "Genevieve O'Reilly Mon Mothma" },
        { n: "FA-HD", name: "Harrison Davis Pommet Warrick" },
        { n: "FA-IW", name: "Ian Whyte Vetch" },
        { n: "FA-JS", name: "Joplin Sibtain Brasso" },
        { n: "FA-JSW", name: "Jecobi Swain Jayco" },
        { n: "FA-KF", name: "Karen Fukuhara F" },
        { n: "FA-KS", name: "Kyle Soller Syril Karn" },
        { n: "FA-KSA", name: "Katee Sackhoff Bo-Katan Kryze" },
        { n: "FA-MB", name: "Matt Berry 8D8" },
        { n: "FA-MBO", name: "Mark Boone Jr. Ranzar Malk" },
        { n: "FA-MEM", name: "Mary Elizabeth McGlynn Governor Pryce" },
        { n: "FA-MM", name: "Molly Miller Agira" },
        { n: "FA-MQ", name: "Ming Qiu Minas Velti" },
        { n: "FA-MV", name: "Myrna Velasco Torra Doza" },
        { n: "FA-MW", name: "Ming-Na Wen Fennec Shand" },
        { n: "FA-NC", name: "Nazneen Contractor Synara San" },
        { n: "FA-NK", name: "Nalini Krishan Bariss Offee" },
        { n: "FA-NN", name: "Nick Nolte Kuiil" },
        { n: "FA-OA", name: "Omid Abtahi Dr. Pershing" },
        { n: "FA-PL", name: "Paul Sun-Hyung Lee Carson Teva" },
        { n: "FA-RB", name: "Richard Brake Valin Hess" },
        { n: "FA-RM", name: "Ryder McLaughlin Wade Resselian" },
        { n: "FA-SG", name: "Sarah Michelle Gellar Seventh Sister" },
        { n: "FA-SM", name: "Suzie McGrath Tam Ryvora" },
        { n: "FA-TM", name: "Temuera Morrison Boba Fett" },
        { n: "FA-TR", name: "Tim Rose Admiral Ackbar" },
        { n: "FA-VB", name: "Vivien Lyra Blair Princess Leia Organa" },
    ],
  },
  {
    id: "prime-autographs",
    type: "auto",
    title: "PRIME AUTOGRAPHS",
    parallels: [
        { id: "base", name: "", print_run: 10, color: "#c8d8f0" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "PA-AD", name: "Adam Driver Kylo Ren" },
        { n: "PA-HC", name: "Hayden Christensen Darth Vader" },
        { n: "PA-HF", name: "Harrison Ford Han Solo" },
        { n: "PA-LN", name: "Lupita Nyong'o Maz Kanata" },
        { n: "PA-MI", name: "Moses Ingram Reva" },
        { n: "PA-SJ", name: "Samuel L. Jackson Mace Windu" },
    ],
  },
  {
    id: "sketch-cards",
    type: "sketch",
    title: "SKETCH CARDS",
    parallels: [
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SK-1", name: "Quinton Baker" },
        { n: "SK-2", name: "Jonathan Beistline" },
        { n: "SK-3", name: "Bobby Blakey" },
        { n: "SK-4", name: "Isiah Xavier Bradley" },
        { n: "SK-5", name: "Neil Brady" },
        { n: "SK-6", name: "Neil Camera" },
        { n: "SK-7", name: "Oscar Chavez" },
        { n: "SK-8", name: "Kevin Cleveland" },
        { n: "SK-9", name: "Roy Cover" },
        { n: "SK-10", name: "Mike Dalzell" },
        { n: "SK-11", name: "Jason Davies" },
        { n: "SK-12", name: "Chenduz D'Ippolito" },
        { n: "SK-13", name: "Dean Drummond" },
        { n: "SK-14", name: "Marcia Dye" },
        { n: "SK-15", name: "Ryan Finley" },
        { n: "SK-16", name: "Gerry Garcia Jr." },
        { n: "SK-17", name: "Elise Gegauff" },
        { n: "SK-18", name: "Nick Gribbon" },
        { n: "SK-19", name: "Jessica Hickman" },
        { n: "SK-20", name: "Brad Hudson" },
        { n: "SK-21", name: "Julie Hunt" },
        { n: "SK-22", name: "Kevin Scott Jacobs" },
        { n: "SK-23", name: "Basak Kahraman" },
        { n: "SK-24", name: "Debjit Kar" },
        { n: "SK-25", name: "Shyla Lee" },
        { n: "SK-26", name: "Veronica Louro" },
        { n: "SK-27", name: "Michael Mastermaker" },
        { n: "SK-28", name: "Eric Medina" },
        { n: "SK-29", name: "Jason Montoya" },
        { n: "SK-30", name: "Michael Munshaw" },
        { n: "SK-31", name: "Dawn Murphy" },
        { n: "SK-32", name: "Jackson Ong" },
        { n: "SK-33", name: "Chris Owens" },
        { n: "SK-34", name: "Anthony Pietszak" },
        { n: "SK-35", name: "John Pleak" },
        { n: "SK-36", name: "Bill Pulkovski" },
        { n: "SK-37", name: "Jane Rushton" },
        { n: "SK-38", name: "Brent Scotchmer" },
        { n: "SK-39", name: "Matt Stewart" },
        { n: "SK-40", name: "Gregory Tilson" },
        { n: "SK-41", name: "Ryan Thompson" },
        { n: "SK-42", name: "Emre Varlibas" },
        { n: "SK-43", name: "Zach Woolsey" },
    ],
  },
  {
    id: "shaped-sketch-cards",
    type: "sketch",
    title: "SHAPED SKETCH CARDS",
    parallels: [
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SSK-1", name: "Adam Beck" },
        { n: "SSK-2", name: "Dwayne Carpenter" },
        { n: "SSK-3", name: "Nick Gribbon" },
        { n: "SSK-4", name: "Benjamin Lombart" },
        { n: "SSK-5", name: "Veronica Louro" },
        { n: "SSK-6", name: "Jenna McGrath" },
        { n: "SSK-7", name: "Ian McKesson" },
        { n: "SSK-8", name: "Jane Rushton" },
        { n: "SSK-9", name: "Jason Sobol" },
        { n: "SSK-10", name: "Ryan Thompson" },
        { n: "SSK-11", name: "Emre Varlibas" },
        { n: "SSK-12", name: "Trent Westbrook" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
